module.exports = __webpack_public_path__ + "static/img/qt_1.a990920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/qt_1.png
// module id = uIN8
// module chunks = 1